import {ModelError} from '@/rest'
import i18n from '@/i18n'

export function AssetAPIError(error: ModelError): string {
    if (error && error.errorcode) {
        switch(error.errorcode) {
            case '209':
                return i18n.t('warningImageDeclined').toString()

            default:
                return error.description || i18n.t('unknownError').toString()
        }
    }
    return i18n.t('unknownError').toString()
}